module.exports = __webpack_public_path__ + "img/iconProjectMessagePush.e44e4d99.svg";